import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowCheckbox, FormikRowInput} from "@components/panel/formik";
import ReactDatePicker from "react-datepicker";

const BaseInfoBlock: FC = () => {

    const {
        values,
        setFieldValue,
    } = useFormikContext<{startTime: Date, endTime: Date}>();

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">
                Основное
            </Card.Header>
            <Card.Body>
                <Field
                    label='Название'
                    type='text'
                    name='name'
                    placeholder='Название группы'
                    component={FormikRowInput}
                />
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Время начала</Form.Label>
                    <Col sm={9}>
                        <ReactDatePicker
                            selected={values.startTime}
                            id="startTime"
                            name="startTime"
                            onChange={(date: Date | null) => setFieldValue('startTime', date)}
                            showTimeInput
                            timeInputLabel="Время:"
                            dateFormat="dd.MM.yyyy HH:mm"
                            className="form-control"
                            placeholderText="Введите дату начала" />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Время окончания</Form.Label>
                    <Col sm={9}>
                        <ReactDatePicker
                            selected={values.endTime}
                            id="endTime"
                            name="endTime"
                            onChange={(date: Date | null) => setFieldValue('endTime', date)}
                            showTimeInput
                            timeInputLabel="Время:"
                            dateFormat="dd.MM.yyyy HH:mm"
                            className="form-control"
                            placeholderText="Введите дату окончания" />
                    </Col>
                </Form.Group>
                <Field
                    label='Активно'
                    type="switch"
                    id="isActive"
                    name="isActive"
                    component={FormikRowCheckbox}
                />
            </Card.Body>
        </Card>
    )
}

export default BaseInfoBlock;
